module.exports = __webpack_public_path__ + "static/media/7266786_sigma_sum_total_greek_icon.07035dd5.ico";